import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "index-lead-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "index-lead-block" }
const _hoisted_4 = {
  id: "myCarousel",
  class: "carousel slide"
}
const _hoisted_5 = { class: "carousel-indicators" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  id: "carousel-inner",
  class: "carousel-inner",
  role: "listbox"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["innerHTML"]

import { ref, toRefs } from "vue";
import { useLogger } from "vue-logger-plugin";

// Define Component Input Properties

export default /*#__PURE__*/_defineComponent({
  __name: 'Article',
  props: {
    title: String,
    numberOfSlides: Number,
},
  setup(__props) {

const props = __props;



// get back slide card info
const { title, numberOfSlides } = toRefs(props);
const maxNumberOfSlides = numberOfSlides?.value;

// logger for information
const logger = useLogger();
// this is what slide we're on
const currentActive = ref(0);
const leftActive = ref(null);
const rightActive = ref(null);
const nextActive = ref(null);
const prevActive = ref(null);
const activelySliding = ref(-1);

// every 8 seconds go to the next slide if there are more slides
if (numberOfSlides?.value > 1) {
    setInterval(function () {
        nextSlide(1);
    }, 8000);
}

// resets a single slide
const removeSlideClass = function (slide, className) {
    if (slide !== null && slide >= 0 && slide < maxNumberOfSlides) {
        logger.debug(`resetting class for slide ${slide}`);
        const topElement = document.getElementById("carousel-inner");
        topElement.children[slide].classList.remove(className);
    }
};

// reset all slide back to 0
const resetAllSlides = function () {
    logger.debug("calling reset all slides classes");
    const topElement = document.getElementById("carousel-inner");
    for (let idx = 0; idx < maxNumberOfSlides; idx++) {
        topElement.children[idx].classList.remove(
            "active",
            "next",
            "prev",
            "left",
            "right"
        );
    }
};

// add class to the inner slide
const addSlideClass = function (slide, className, updateActiveSlide = false) {
    if (slide !== null && slide >= 0 && slide < maxNumberOfSlides) {
        if (updateActiveSlide) {
            logger.debug(`updating currentActive slide to ${slide}`);
            // update the currently active slide to this slide
            currentActive.value = slide;
        }

        logger.debug(`adding class ${className} to slide ${slide} `);
        // add class to the current slide
        const topElement = document.getElementById("carousel-inner");
        topElement.children[slide].classList.add(className);
    }
};

// for when the indicator bubbles are clicked go directly to the page in question
const onIndicatorClick = function (slide) {
    logger.debug(`indicator clicked for slide ${slide}`);
    resetAllSlides();
    addSlideClass(slide, "active", true);
};

// when next or prev buttons are clicked
const nextSlide = function (direction) {
    // do not slide until we're able to
    if (activelySliding.value >= 0) {
        return;
    }

    let slide = currentActive.value;

    // set that we're actively sliding to the next card
    activelySliding.value = slide;

    // positive means going next slide
    if (direction > 0) {
        leftActive.value = slide;
        slide++;

        // keep it in bound
        if (slide >= maxNumberOfSlides) {
            slide = 0;
        }

        setTimeout(function () {
            // next active is the one we want
            nextActive.value = slide;
            addSlideClass(nextActive.value, "next");
        }, 500);

        // make slide active and left slide left
        addSlideClass(leftActive.value, "left");
    } else {
        rightActive.value = slide;
        slide--;

        // keep the slide in bound
        if (slide < 0) {
            slide = maxNumberOfSlides - 1;
        }

        setTimeout(function () {
            // previous active is up next
            prevActive.value = slide;
            addSlideClass(prevActive.value, "prev");
        }, 500);

        // make slide active and right slide right
        addSlideClass(rightActive.value, "right");
    }

    // this time out sets the current active value so the carousel looks like it is "sliding"
    setTimeout(function () {
        // reset the currently active slide before we move
        removeSlideClass(currentActive.value, "active");

        // reset the next and prev values
        if (nextActive.value != null) {
            currentActive.value = nextActive.value;
        } else {
            currentActive.value = prevActive.value;
        }

        // this should already be done but re-do it just in case it got reset in a timer
        addSlideClass(currentActive.value, "active");

        // reset the other slides
        removeSlideClass(leftActive.value, "left");
        removeSlideClass(rightActive.value, "right");
        removeSlideClass(prevActive.value, "prev");
        removeSlideClass(nextActive.value, "next");

        // reset all values
        leftActive.value =
            rightActive.value =
            prevActive.value =
            nextActive.value =
                null;

        // we're no longer sliding so indicate that
        activelySliding.value = -1;
    }, 1000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("ol", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maxNumberOfSlides), (idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                onClick: ($event: any) => (onIndicatorClick(idx - 1))
              }, null, 8, _hoisted_6))
            }), 128))
          ], 512), [
            [_vShow, _unref(numberOfSlides) > 1]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _withDirectives(_createElementVNode("a", {
            class: "left carousel-control",
            href: "#myCarousel",
            role: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (nextSlide(-1)), ["prevent"]))
          }, _hoisted_10, 512), [
            [_vShow, _unref(numberOfSlides) > 1]
          ]),
          _withDirectives(_createElementVNode("a", {
            class: "right carousel-control",
            href: "#myCarousel",
            role: "button",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nextSlide(1)), ["prevent"]))
          }, _hoisted_13, 512), [
            [_vShow, _unref(numberOfSlides) > 1]
          ]),
          _createElementVNode("h1", {
            class: "hidden-header",
            style: {"z-index":"1"},
            innerHTML: decodeURIComponent(_unref(title))
          }, null, 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}
}

})